/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var Chart: any;
namespace Nobox.NoBoxCRM {

    interface DoughnutChartData {
        type: string;
        labels: string[];
        legend: boolean;
        datasets: {
            label: string;
            borderColor: string;
            backgroundColor: string[];
            data: number[];
        }[];
    };

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class AnalyticsDialog extends NoboxEntityDialog<FormRow, any> {
        protected getFormKey() { return AnalyticsForms.formKey; }
        protected getIdProperty() { return FormRow.idProperty; }
        protected getLocalTextPrefix() { return FormRow.localTextPrefix; }
        protected getNameProperty() { return FormRow.nameProperty; }
        protected getService() { return FormService.baseUrl; }
        protected getDeletePermission() { return FormRow.deletePermission; }
        protected getInsertPermission() { return FormRow.insertPermission; }
        protected getUpdatePermission() { return FormRow.updatePermission; }

        protected form = new AnalyticsForms(this.idPrefix);

        charts: any[] = [];
        defaultChart: DoughnutChartData = {
            type: 'doughnut',
            labels: ["Pending", "Process", "Complete", "Refund", "Cancel"],
            legend: true,
            datasets: [{
                label: "",
                borderColor: "#fff",
                backgroundColor: ["#b5b5b5", "#f39c12", "#53BF9D", "#D61C4E", "#D61C4E"],
                data: [1, 2, 3, 4, 5]
            }]
        };

        constructor() {
            super();
        }
        getLoadByIdRequest(Id) {
            var request = super.getLoadByIdRequest(Id);
            //request.ColumnSelection = 1;
            request.IncludeColumns = ["Id", "Name", "Data", "Payment", "Type"];
            return request;
        }
        loadByIdHandler(options: Serenity.ServiceOptions<Serenity.RetrieveResponse<FormRow>>, callback: (response: Serenity.RetrieveResponse<FormRow>) => void, fail: () => void) {
            options.onSuccess = (item) => {
                FormresultsService.List({
                    IncludeColumns: ["Id", "St", "Data", "Form", "IsPaid"],
                    ColumnSelection: 1,
                    EqualityFilter: {
                        FormId: options.request.EntityId
                    }
                }, (resResult) => {
                    var result = item;
                    result.Entity.ListAnswer = resResult.Entities;
                    this.loadResponse(result);
                    callback && callback(result);
                });
            }
            super.loadByIdHandler(options, callback, fail)
        }
        dialogOpen() {
            super.dialogOpen();

            this.element.children("div.panel-titlebar").addClass("row");
            this.element.children("div.panel-titlebar").find("button.panel-titlebar-close").remove();
            this.element.children("div.panel-titlebar").prepend(`<div class="col-0 col-lg-2"></div>`)
            this.element.children("div.panel-titlebar").find(".panel-titlebar-text").addClass("col-11 col-lg-7");
            this.element.children("div.panel-titlebar").append(`<div class="col-1"><a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;max-width:43px;" class="btn btn-icon btn-sm p-0 ml-1 float-right" target="_blank" href="${$('#GridDiv').attr('help-url')}">
                    <div class="tool-button icon-tool-button" title="Help">
                        <div class="button-outer">
                            <span class="button-inner green">
                                <i class="fa fa-question-circle text-blue"></i>
                            </span>
                        </div>
                    </div>
                </a></div>`);
        }
        isValidJSON(jsonString) {
            try {
                JSON.parse(jsonString);
                return true;
            } catch (error) {
                return false;
            }
        }
        generateDistinctColorArray(length) {
            const colorArray = ["#4c5052", "#5cb85c"];

            // Fungsi untuk menghasilkan warna acak dengan batasan jarak warna
            function getRandomColor() {
                return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
            }

            // Fungsi untuk menghitung jarak warna dalam ruang warna HSL
            function getColorDifference(color1, color2) {
                const rgbToHsl = (r, g, b) => {
                    r /= 255, g /= 255, b /= 255;
                    const max = Math.max(r, g, b), min = Math.min(r, g, b);
                    let h, s, l = (max + min) / 2;

                    if (max === min) {
                        h = s = 0; // grayscale
                    } else {
                        const d = max - min;
                        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                        switch (max) {
                            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                            case g: h = (b - r) / d + 2; break;
                            case b: h = (r - g) / d + 4; break;
                        }
                        h /= 6;
                    }

                    return [h, s, l];
                };

                const hsl1 = rgbToHsl(parseInt(color1.slice(1, 3), 16), parseInt(color1.slice(3, 5), 16), parseInt(color1.slice(5, 7), 16));
                const hsl2 = rgbToHsl(parseInt(color2.slice(1, 3), 16), parseInt(color2.slice(3, 5), 16), parseInt(color2.slice(5, 7), 16));

                return Math.abs(hsl1[0] - hsl2[0]) + Math.abs(hsl1[1] - hsl2[1]) + Math.abs(hsl1[2] - hsl2[2]);
            }

            for (let i = 0; i < length; i++) {
                let color = getRandomColor();

                // Ensure the generated color is distinct from existing colors
                while (colorArray.some(existingColor => getColorDifference(color, existingColor) < 0.5)) {
                    color = getRandomColor();
                }

                colorArray.push(color);
            }

            return colorArray;
        }
        updateInterface() {
            super.updateInterface();
            if (this.isEditMode()) {
                var item = this.get_entity();
                var listSelectedTemplate = [];
                var listTemplate = [] as Array<form>;
                if (!Q.isEmptyOrNull(item.Data) && this.isValidJSON(item.Data)) {
                    listTemplate = JSON.parse(item.Data);
                }

                listTemplate.forEach((x) => {
                    var field = x.settings.field;
                    var type = x.settings.inputType;
                    x["chart"] = {};
                    if (x.isShow) {
                        if (field == "input") {
                            if (type == "radio") {
                                listSelectedTemplate.push(x);
                            } else if (type == "checkbox") {
                                listSelectedTemplate.push(x);
                            }
                        } else if (field == "select") {
                            listSelectedTemplate.push(x);
                        }
                    }
                });

                var listResult: Array<form> = [];
                var dataStatus = [0, 0, 0, 0, 0]
                var dataPaid = [0, 0];
                var payments = [];
                var dataPayments = [];
                item.ListAnswer.forEach((la: FormresultsRow) => {
                    if (!Q.isEmptyOrNull(la.Data) && this.isValidJSON(la.Data)) {
                        var tempArr = JSON.parse(la.Data);
                        if (tempArr.dataField) {
                            tempArr.dataField.forEach(ta => {
                                listResult.push(ta);
                            });
                        };
                        if (tempArr.dataPay) {
                            dataPayments.push(tempArr.dataPay);
                        }
                    }

                    if (la.St == 0) {
                        dataStatus[0] = dataStatus[0] + 1;
                    } else if (la.St == 1) {
                        dataStatus[1] = dataStatus[1] + 1;
                    } else if (la.St == 2) {
                        dataStatus[2] = dataStatus[2] + 1;
                    } else if (la.St == 3) {
                        dataStatus[3] = dataStatus[3] + 1;
                    } else if (la.St == 4) {
                        dataStatus[4] = dataStatus[4] + 1;
                    }
                    if (la.IsPaid == 1) {
                        dataPaid[1] = dataPaid[1] + 1;
                    } else {
                        dataPaid[0] = dataPaid[0] + 1;
                    }
                });
                this.renderChart(`1St`, `Status`, `Results ${item.ListAnswer.length}`, `doughnut`, {
                    labels: ["Pending", "Process", "Complete", "Refund", "Cancel"],
                    type: "bar",
                    legend: false,
                    datasets: [{
                        label: "Status",
                        borderColor: "#fff",
                        backgroundColor: ["#4c5052", "#5bc0de", "#5cb85c", "#CC99FF", "#d9534f"],
                        data: dataStatus
                    }]
                });

                this.renderChart(`Paid`, `Payment Status`, `Results ${item.ListAnswer.length}`, `doughnut`, {
                    labels: ["Unpaid", "Paid"],
                    type: "doughnut",
                    legend: true,
                    datasets: [{
                        label: "",
                        borderColor: "#fff",
                        backgroundColor: this.generateDistinctColorArray(2),
                        data: dataPaid
                    }]
                });
                if (item.Type != 1) {
                    payments = JSON.parse(item.Payment) as any[];
                    if (payments != null) {
                        var pfiltered = payments.filter(x => x.isShow);
                        //if (pfiltered.length != 1 && pfiltered.length != 0) {
                        //    var dataP = []
                        //    var label = pfiltered.map(pf => {
                        //        dataP.push(0);
                        //        return pf.name
                        //    });
                        //    var arrPType = pfiltered.map(pf => {
                        //        return pf.id
                        //    });
                        //    dataPayments.forEach(dp => {
                        //        var dptype = dp.type - 1;
                        //        var indexp = arrPType.indexOf(dptype);
                        //        if (indexp != -1) {
                        //            if (dataP[indexp]) {
                        //                dataP[indexp] = dataP[indexp] + 1;
                        //            } else {
                        //                dataP[indexp] = 1;
                        //            }
                        //        }
                        //    });
                        //    this.renderChart(`PaymentMethod`, `Payment Method`, `Results ${item.ListAnswer.length}`, `doughnut`, {
                        //        labels: label,
                        //        type: "doughnut",
                        //        legend: true,
                        //        datasets: [{
                        //            label: "",
                        //            borderColor: "#fff",
                        //            backgroundColor: this.generateDistinctColorArray(label.length),
                        //            data: dataP
                        //        }]
                        //    });
                        //}
                        var labelAccP = [];
                        var dataAccP = [];
                        var idAccP = [];
                        dataPayments.forEach((dp, dpi) => {
                            if (dp.list) {
                                if (dpi == 0) {
                                    labelAccP = dp.list.map(dpl => {
                                        dataAccP.push(0);
                                        idAccP.push(dpl.Id);
                                        return dpl.Name;
                                    });
                                }
                            }
                            var indexdp = idAccP.indexOf(Number(dp.selected));
                            if (indexdp != -1) {
                                if (dataAccP[indexdp]) {
                                    dataAccP[indexdp] = dataAccP[indexdp] + 1;
                                } else {
                                    dataAccP[indexdp] = 1;
                                }
                            }
                        });
                        this.renderChart(`PaymentAccount`, `Payment Accounts`, `Results ${item.ListAnswer.length}`, `doughnut`, {
                            labels: labelAccP,
                            type: "doughnut",
                            legend: true,
                            datasets: [{
                                label: "",
                                borderColor: "#fff",
                                backgroundColor: this.generateDistinctColorArray(labelAccP.length),
                                data: dataAccP
                            }]
                        });
                    }
                }
                if (listSelectedTemplate.length != 0) {
                    listResult.forEach((x) => {
                        var field = x.settings.field;
                        var type = x.settings.inputType;

                        var checkTemplate = listSelectedTemplate.findIndex(fx => fx.id == x.id && fx.settings.field == field && fx.settings.inputType == type);
                        if (checkTemplate != -1) {
                            if (x.value) {
                                let selected = listSelectedTemplate[checkTemplate].chart;
                                var value = x.value;
                                if (field == "select") {
                                    var objVal = JSON.parse(x.value)
                                    if (objVal.text) {
                                        value = objVal.text;
                                    }
                                    if (Q.isEmptyOrNull(value)) {
                                        if (selected[value]) {
                                            selected[value] = selected[value];
                                        } else {
                                            selected[value] = 0;
                                        }
                                    } else {
                                        if (selected[value]) {
                                            selected[value] = selected[value] + 1;
                                        } else {
                                            selected[value] = 1;
                                        }
                                    }
                                } else {
                                    let selectOpsi = x.settings.selectOpsi;
                                    if (selectOpsi != null) {
                                        selectOpsi.forEach(so => {
                                            if (so.id == value) {
                                                if (selected[so.name]) {
                                                    selected[so.name] = selected[so.name] + 1;
                                                } else {
                                                    selected[so.name] = 1;
                                                }
                                            }
                                            if (so.id != value) {
                                                if (selected[so.name]) {
                                                    selected[so.name] = selected[so.name];
                                                } else {
                                                    selected[so.name] = 0;
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    });
                    listSelectedTemplate.forEach((x) => {
                        if (x["chart"]) {
                            var keys = Object.keys(x["chart"]);
                            var values = [];
                            var total = 0;
                            var typeChart = "doughnut";
                            if (keys.length > 5) {
                                typeChart = "bar";
                            }
                            for (const key in x["chart"]) {
                                if (x["chart"].hasOwnProperty(key)) {
                                    values.push(x["chart"][key]);
                                    if (x["chart"][key]) {
                                        total = total + x["chart"][key];
                                    }
                                }
                            }

                            this.renderChart(`${x.id}`, `${x.settings.label}`, `Answer ${total}/${item.ListAnswer.length}`, `${x.settings.field}`, {
                                labels: keys,
                                type: typeChart,
                                legend: true,
                                datasets: [{
                                    label: "",
                                    borderColor: "#fff",
                                    backgroundColor: this.generateDistinctColorArray(keys.length),
                                    data: values
                                }]
                            });
                        } else {
                            this.renderChart(`${x.id}`, `${x.settings.label}`, `Answer ${0}/${item.ListAnswer.length}`, `${x.settings.field}`, {
                                labels: [],
                                type: "doughnut",
                                legend: true,
                                datasets: [{
                                    label: "",
                                    borderColor: "#fff",
                                    backgroundColor: [],
                                    data: []
                                }]
                            });
                        }
                    })
                }
                else {

                }
            }
        }
        dialogClose() {

        }
        renderDataSet() {

        }
        updateTitle() {
            this.dialogTitle = `Form Analytics - ${this.get_entity().Name}`;
            $("title").text(this.dialogTitle);
        }

        generateShortUUID() {
            return Math.floor(1000 + Math.random() * 9000).toString();
        }

        renderChart(id: string, title: string, total: string, type, chartOption: DoughnutChartData) {
            var Id = `${id}`;
            var chart = $(`
        <div class="col-0 col-lg-2"></div>
        <section class="col-lg-8 col-12 mt-2">
                <div class="card s-dashboard-card">
                    <div class="card-header">
                        <h5 class="card-title fw-bold">${title}</h5>
                        <div>Total ${total}</div>
                    </div>
                    <div class="card-body">
                        <canvas id="${Id}" style="height: 350px;"></canvas>
                    </div>
                </div>
        </section>
        <div class="col-0 col-lg-2"></div>`);
            var options = {
                legend: {
                    display: chartOption.legend
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: 1,
                            beginAtZero: true
                        }
                    }]
                },
                responsive: true,
                maintainAspectRatio: false
            } as any;
            if (chartOption.type == "doughnut") {
                options = {
                    legend: {
                        display: chartOption.legend
                    },
                    responsive: true,
                    maintainAspectRatio: false
                };
            }
            new Chart(chart.find(`#${Id}`).get(0), {
                type: chartOption.type,
                data: {
                    labels: chartOption.labels,
                    dataUnit: '',
                    datasets: chartOption.datasets
                },
                options: options
            });
            this.byId("wrapperchart").append(chart);
        }

        getTemplate() {
            return `<div class="s-DialogContent">
                        <div id="~_Toolbar" class="s-DialogToolbar hidden">
                        </div>
                        <div class="s-Form hidden">
                            <form id="~_Form" action="">
                                <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                    <div id="~_PropertyGrid"></div>
                                    <div class="clear"></div>
                                </div>
                            </form>
                        </div>
                        <div id="~_wrapperchart" class="row">
                        </div>
                    </div>`;
        }
    }
}
